/* eslint-disable */
import React, {
  useContext,
  useEffect,
  useState,
  Fragment,
  useRef,
  useCallback,
} from "react";
import styled from "styled-components";
import cx from "classnames";
import swal from "sweetalert";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { AppContext } from "../../../../components/AppProvider";
import { _API, _CK, _U } from "../../../../modules/utils";
import { DynamicStyles } from "../Resources/GlobalStyle";
import { resolveCanonicalEnv, CANONICAL_HOSTS } from "../../../../modules/config/environment";

import ChromeLogo from "../../../../resources/login/image/chrome.png";
import SafariLogo from "../../../../resources/login/image/safari.png";
import EdgeLogo from "../../../../resources/login/image/edge.png";
import WinrevairThumbnail from "../../../../resources/login/image/winrevair.svg";
import defaultImg from "../../../../resources/console/images/icon/noneimg.png";

import { cardClasses } from "@mui/material";

import LoginPasscodeView from "./Login.Passcode.View"
import LoginMemberView from "./Login.Member.View"
import LoginGuestView from "./Login.Guest.View"
import LoginParticipationView from "./Login.ParticipationCode.View"
import useStore from "../../../../modules/utils/store";
import { isAndroid, isTablet } from "react-device-detect";
import hostUtils from "../../../../modules/utils/playerUnmount";

// Windows Edge 등에서 DOM Storage가 비활성화(인터넷 옵션·그룹정책·쿠키 전체 차단)되면
// window.localStorage 속성 접근 자체가 SecurityError를 던진다.
// 로그인 흐름(WebSocket 핸들러)이 통째로 죽지 않도록 안전하게 감싼다.
const safeLocalStorage = {
  setItem(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      /* DOM Storage 비활성 환경 무시 */
    }
  },
  removeItem(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (e) {
      /* DOM Storage 비활성 환경 무시 */
    }
  },
};

// 로딩 스피너 스타일
const LoadingSpinner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  
  .spinner {
    width: 50px;
    height: 50px;
    border: 5px solid rgba(255, 255, 255, 0.3);
    border-top: 5px solid #fff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  .loading-text {
    position: absolute;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    margin-top: 80px;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export default (props) => {
  const { isLocalDevHost } = hostUtils;
  const { auth, saveAuth, saveIam } = useContext(AppContext);
  const { match, eventIdx } = props;
  const history = useHistory();  // ✅ 이제 Router 안에 있으므로 작동함
  const { siteInfo } = useStore();
  const [info, setInfo] = useState({});
  const [loginTabArray, setLoginTabArray] = useState([]);
  const [tab, setTab] = useState();
  const loginEventIdx = eventIdx || match?.params.eventIdx || null;
  const [eventList, setEventList] = useState([]);
  const [campaignList, setCampaignList] = useState([]);
  const [visibleCampaignCount, setVisibleCampaignCount] = useState(3);
  const [idCheck, setIdCheck] = useState(_CK.get("idCheck"));
  const [loginType, setLoginType] = useState("login");
  const [member, setMember] = useState({});
  const [termsInfo, setTermsInfo] = useState(null);
  const [findMember, setFindMember] = useState({});
  const [scrollY, setScrollY] = useState(0);
  const [passcodeNext, setPasscodeNext] = useState(null);
  const [preregEventList, setPreregEventList] = useState([]);
  const documentRef = useRef(document);
  const [accessKey, setAccessKey] = useState(null);
  const [iam, setIam] = useState(null);
  const [guestInfoList, setGuestInfoList] = useState(null);
  const [passCodeOpt, setPassCodeOpt] = useState([]);
  const [passCodePrivacyOpen, setPassCodePrivacyOpen] = useState(false);
  const [passCodeUseOpen, setPassCodeUseOpen] = useState(false);
  const [passCodeOverseaOpen, setPassCodeOverseaOpen] = useState(false);
  const [passCodeTopOpen, setPassCodeTopOpen] = useState(false);
  const [passCodePrivacyAgree, setPassCodePrivacyAgree] = useState(false);
  const [passCodeUseAgree, setPassCodeUseAgree] = useState(false);
  const [passCodeOverseaAgree, setPassCodeOverseaAgree] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [openModal, setOpenModal] = useState(null); 
  const [firstLoginStatus, setFirstLoginStatus] = useState(1);
  const [loginError, setLoginError] = useState(null); // ✅ 로그인 에러 메시지 상태 추가
  const [gstTermsUseYn, setGstTermsUseYn] = useState(false);
  const [gstTermsMarketYn, setGstTermsMarketYn] = useState(false);
  const [gstTermsOverseaYn, setGstTermsOverseaYn] = useState(false);
  const [gstTermsPrivacyYn, setGstTermsPrivacyYn] = useState(false);
  
  // WebSocket for non-local environments
  const [ws, setWs] = useState(null);
  const [connectionId, setConnectionId] = useState(null);
  const [isWsReady, setIsWsReady] = useState(false);
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [wsRetry, setWsRetry] = useState(0);

  const isKakao = navigator.userAgent.match("KAKAOTALK");
  const isSamsungBrowser = /SamsungBrowser/i.test(navigator.userAgent);
  
  // 로컬 환경 감지
  const isLocalEnv = isLocalDevHost(window.location.hostname);

  const urlName = window.location.href;

  const cleanUrl = urlName.replace(/^https?:\/\//, '');
  const preregAllowedOrigins = [
    "http://localhost:3001",
    "http://test1.onoffevent.com:3001"
  ];
  const showPreregPromotion = isLocalEnv || preregAllowedOrigins.includes(window.location.origin);

  let userAgent = navigator.userAgent.toLowerCase();

  let iosOk = /iphone|ipad|ipod/.test(userAgent);

  const openInChrome = () => {

    userAgent = navigator.userAgent.toLowerCase();
    const isAndroid = /android/.test(userAgent);
    const isIOS = /iphone|ipad|ipod/.test(userAgent);

    if (isAndroid) {

      // intent URL은 첫 `#`을 `#Intent;...` 구분자로 사용하므로 target URL에 `#`을 포함할 수 없다.
      // HashRouter `#`을 `%23`으로 인코딩하면 Chrome 주소창에 `%23`이 리터럴로 남아 라우팅이 깨지므로
      // hash/query를 제거한 host+pathname만 전달하고 라우팅은 앱(HashRouter)이 처리하게 한다.
      const target = window.location.host + window.location.pathname;
      const fallbackUrl = encodeURIComponent("https://play.google.com/store/apps/details?id=com.android.chrome");
      // Galaxy(OneUI)에서 삼성 인터넷이 기본 브라우저면 OS가 "열기" picker를 강제로 띄울 수 있음.
      // 웹 레벨에서 picker를 강제로 없애는 건 Samsung/OneUI 정책상 불가능 — action/category로 가능한 만큼만 라우팅을 엄격히 한다.
      const intentUrl = `intent://${target}#Intent;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;scheme=https;package=com.android.chrome;S.browser_fallback_url=${fallbackUrl};end`;

      window.location.href = intentUrl;

    } else if (isIOS) {

      const appStoreUrl = "https://apps.apple.com/app/google-chrome/id535886823";

      // iOS Chrome 딥링크 스킴: HTTP는 `googlechrome://`, HTTPS는 `googlechromes://`.
      // 잘못된 스킴을 쓰면 Chrome이 설치돼 있어도 열리지 않는다.
      const isHttps = /^https:\/\//i.test(urlName);
      const chromeScheme = isHttps ? 'googlechromes://' : 'googlechrome://';

      window.location.href = chromeScheme + cleanUrl;

      window.onblur = () => {
        setTimeout(() => {
          window.location.href = appStoreUrl;
        }, 1000);
      };

    } else {
        window.location.href = "https://www.google.com/chrome/"
    }

  }

  const openInEdge = () => {

    userAgent = navigator.userAgent.toLowerCase();
    const isAndroid = /android/.test(userAgent);
    const isIOS = /iphone|ipad|ipod/.test(userAgent);

    if (isAndroid) {
      // intent URL은 target URL에 `#`을 포함할 수 없어 hash/query 제거. 라우팅은 앱이 처리.
      const target = window.location.host + window.location.pathname;
      const fallbackUrl = encodeURIComponent("https://play.google.com/store/apps/details?id=com.microsoft.emmx");
      // Galaxy(OneUI)에서 picker가 뜰 수 있으나 웹 레벨 강제 우회는 불가 — action/category로 가능한 범위만 엄격히 한다.
      const intentUrl = `intent://${target}#Intent;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;scheme=https;package=com.microsoft.emmx;S.browser_fallback_url=${fallbackUrl};end`;
      window.location.href = intentUrl;
    } else if (isIOS) {

      const edgeDeepLink = `microsoft-edge://navigate?url=${encodeURIComponent(urlName)}`;

      const appStoreUrl = "https://apps.apple.com/app/microsoft-edge/id1288723196";

      window.location.href = edgeDeepLink;

      // Edge가 설치되어 정상적으로 페이지가 백그라운드로 갈 때만 blur가 발생.
      // 설치돼 있지 않으면 blur가 안 일어나므로 그 경우에만 App Store로 이동.
      window.onblur = () => {
        setTimeout(() => {
          window.location.href = appStoreUrl;
        }, 1500);
      };
    } else {
      window.location.href = "https://www.microsoft.com/ko-kr/edge/";
    }

  }

  // console.log("siteInfo ===> ",siteInfo)  // ✅ 디버깅 로그 제거 (렌더링 시마다 실행)

  const handleScroll = useCallback(() => {
    const { pageYOffset } = window;
    setScrollY(pageYOffset);
  }, []);

  // WebSocket 연결 (로컬 환경이 아닐 때만)
  useEffect(() => {
    if (isLocalEnv) {
      setIsWsReady(true);  // 로컬에서는 WebSocket 없이 바로 준비 완료
      return;
    }

    // 실제 환경: WebSocket 연결
    let wsUrl;
    const hostname = window.location.hostname;

    // 신규 canonical(.dev/.stage.livee.kr)은 아래 includes('livee.kr') 보다 먼저 검사해야 한다.
    // ".dev.livee.kr" 도 "livee.kr" 을 포함하므로 순서가 뒤바뀌면 dev 로그인 화면이
    // prod WebSocket 에 연결된다.
    const canonicalEnv = resolveCanonicalEnv(hostname);
    if (canonicalEnv) {
      wsUrl = CANONICAL_HOSTS[canonicalEnv].ws;
    } else if (hostname.includes('onoffevent.com')) {
      wsUrl = 'wss://ws.onoffevent.com';
    } else if (hostname.includes('livee.kr')) {
      wsUrl = 'wss://ws.livee.kr';
    } else if (hostname.includes('sharewebinar.com')) {
      wsUrl = 'wss://ws.sharewebinar.com';
    } else {
      wsUrl = 'wss://ws.onoffevent.com';
    }
    
   
    const socket = new WebSocket(wsUrl);

    socket.onopen = () => {
      
      setWs(socket);
      socket.send(JSON.stringify({ action: 'IAM' }));
    };

    socket.onmessage = (event) => {
      const received = JSON.parse(event.data);
 
      
      const message = received;


      switch (message.action) {
        case 'IAM_SUCCESS':
         
          setConnectionId(message.id);
          safeLocalStorage.setItem('wsConnectionId', message.id);
          
          setIsWsReady(true);
          break;

        case 'LOGIN_RESULT':
          setIsLoggingIn(false);

          if (message.success) {
            const { data, accessKey, tab: responseTab } = message;
            
            if ((responseTab === "PASSCODE" || responseTab === "PARTICIPATION") && accessKey) {
              // 패스코드/고유코드: 이벤트 목록 표시 후 선택하게 함
              _CK.setConsoleCountView(0);
              _CK.forceSetLogKey(data?.logKey);  // ✅ logKey 쿠키 저장
              setIam(data);
              setAccessKey(accessKey);
              setPreregEventList(data.preregEventList);
              setPasscodeNext(true);
            } else if (responseTab === "GUEST" && accessKey) {
              // 🔥 게스트: 이미 이벤트가 선택된 상태, 바로 이동
              _CK.setAuth(accessKey);
              _CK.forceSetLogKey(data?.logKey);
              _CK.setConsoleCountView(0);
              saveIam(data);
              saveAuth(accessKey);
              
              // 게스트는 eventIdx가 이미 선택되어 있으므로 바로 이동
              const guestEventIdx = data?.eventIdx;
              if (guestEventIdx) {
                setTimeout(() => {
                  history.push(`/event/${guestEventIdx}/register`);
                }, 100);
              }
            } else {
              // 회원 등 기타
              _CK.setAuth(accessKey);
              _CK.forceSetLogKey(data?.logKey);
              _CK.setConsoleCountView(0);
              saveIam(data);
              saveAuth(accessKey);
            }

            // 🔧 로그인 성공 시에만 WebSocket을 종료
            try {
              if (socket.readyState === WebSocket.OPEN || socket.readyState === WebSocket.CONNECTING) {
                socket.close();
              }
            } catch (closeError) {
              console.error('[LOGIN_RESULT] Failed to close login WebSocket:', closeError);
            }
            setWs(null);
            setIsWsReady(false);
            setConnectionId(null);
            safeLocalStorage.removeItem('wsConnectionId');
          } else {
            // 로그인 실패 시에는 에러 메시지만 표시하고 연결은 유지합니다.
            setLoginError(message.message || "An unknown error occurred."); // ✅ swal 대신 에러 상태 저장
          }
          break;

        default:
          
      }
    };

    socket.onclose = () => {
      
      setWs(null);
      setIsWsReady(false);
    };

    socket.onerror = (error) => {
      
      setIsLoggingIn(false);
      setIsWsReady(false);
      setLoginError("Could not connect to the login service."); // ✅ swal 대신 에러 상태 저장
    };

    return () => {
      if (socket.readyState === 1) {
        socket.close();
      }
    };
  }, [isLocalEnv, wsRetry]);

  useEffect(() => {
    const newLoginTabArray = [];
     if (siteInfo?.loginMemYn === "Y") {
      newLoginTabArray.push({ order: siteInfo?.loginMemOrd, name: "회원", key: "MEMBER" });
     } 
    if (siteInfo?.loginPassYn === "Y") {
      if(siteInfo?.idx == 125) {
        newLoginTabArray.push({ order: siteInfo?.loginPassOrd, name: "Passcode (패스코드)", key: "PASSCODE" });
      } else {
        newLoginTabArray.push({ order: siteInfo?.loginPassOrd, name: "패스코드", key: "PASSCODE" });
      }
    }
    if (siteInfo?.loginGstYn === "Y") {
      if(siteInfo?.idx == 125) {
        newLoginTabArray.push({ order: siteInfo?.loginGstOrd, name: "Guest (게스트)", key: "GUEST" });
      } else {
        newLoginTabArray.push({ order: siteInfo?.loginGstOrd, name: "게스트", key: "GUEST" });
      }

    }
    // 참가고유코드는 별도 탭이 아니라 패스코드 탭 내 전환 링크로 노출한다(siteInfo.loginPartiYn === "Y").
    newLoginTabArray.sort(function (a, b) {
      return b.order - a.order;
    });
    setLoginTabArray(newLoginTabArray);
    if (newLoginTabArray && newLoginTabArray.length > 0){
      setTab(newLoginTabArray[0].key);
    }
    loadEventList();

    if (siteInfo?.idx > 0) {
      loadPassCodeOption();
      loadCampaignList();
    }
   
    if (_CK.get("idCheck") === "Y" && _CK.get("email")) {
      setInfo((o) => {
        return { ...o, ["email"]: _CK.get("email") };
      });
    }
  }, []);

  const loadPassCodeOption = () => {
    const req = {
      path: "/v1/client/passcodeOpt",
      data: {
        idx : siteInfo.idx,
      },
    };
    _API.post(req).then((res) => {
        const { data } = res;
        setPassCodeOpt(data.data)
    }).catch((e) => {
      console.log(e)
    });
  };

  const loadCampaignList = async () => {
    const req = {
      path: "/v1/campaign/channel/list",
      data: {
        siteIdx : siteInfo.idx,
      },
    };
    await _API.post(req).then((res) => {
        const { data } = res.data;

        console.log('data =', data);

        setCampaignList(data)
    }).catch((e) => {
      console.log(e)
    });
  };

  const handleShowMoreCampaign = () => {
    setVisibleCampaignCount((prev) => Math.min(prev + 3, campaignList.length));
  };

  const onSetInfo = (key, value) => {
    if (key === "RESET") {
      setInfo((o) => {
        return {};
      });
    } else {
      setInfo((o) => {
        return { ...o, [key]: value };
      });
    }
  };

  const onSetEventListActive = (i) => {
    setEventList((o) => {
      const nb = [...o];
      nb.map((key, j) => {
        if (i == j) {
          nb[j].activeYn = nb[i].activeYn === true ? false : true;
        } else {
          nb[j].activeYn = false;
        }
      });
      return nb;
    });
  };

  const onSetGuestInfoList = (key, i, j, value) => {
    setEventList((o) => {
      const nb = [...o];
      nb.map((key2, k) => {
        if (i == k) {
          if (j == null) {
            let newVal = value;

            if (key === "termsPrivateAgree") {
              newVal = nb[i]?.termsPrivateAgree === "Y" ? "N" : "Y";
            } else if (key === "termsUseAgree") {
              newVal = nb[i]?.termsUseAgree === "Y" ? "N" : "Y";
            }
            nb[i] = { ...nb[i], [key]: newVal };
          } else {
            nb[i].preregFieldList[j] = {
              ...nb[i].preregFieldList[j],
              ["value"]: value,
            };
          }
        }
      });
      return nb;
    });
  };

  const loginTabChange = (key, e) => {
    if (e) e.preventDefault();
    setTab(key);
    setInfo({});
    setFindMember({});
  };

  const loadEventList = () => {
    if (!siteInfo.idx) {
      alert("올바른 접근이 아닙니다.");
      return;
    }
    const req = {
      path: "/v1/client/site/event/list",
      data: {
        siteIdx: siteInfo.idx,
        eventProgressStatus: "TODAY",
        eventStatus: "Y",
      },
    };
    
    _API.post(req).then((res) => {
      const { data } = res.data;
      if(data) {
        if (data.length == 1) {
          for (let i in data) {
            if(data[i].upcomingYn == "Y" || data[i].onAirYn == "Y") {
              data[i].activeYn = true
            } else {
              data[i].activeYn = false
            }
          }
        } else {
          for(let i in data) {
            data[i].activeYn = false
          }
        }
        setEventList(data);
      }
    });
  };

  

  const clickedIdCheck = () => {
    const idCheck = _CK.get("idCheck");
    if (idCheck === "Y") {
      _CK.set("idCheck", "N");
      setIdCheck("N");
    } else {
      _CK.set("idCheck", "Y");
      setIdCheck("Y");
    }
  };

  const onLoginClick = (e) => {
    
    if(e) e.preventDefault();
    
    // ✅ 로그인 시도 시 에러 초기화
    setLoginError(null);
    
    // 실제 환경에서만 WebSocket 연결 + connectionId
    if (!isLocalEnv && (!isWsReady || !connectionId)) {
      setLoginError("Please wait a moment for the login service to connect."); // ✅ swal 대신 에러 상태
      setWsRetry(c => c + 1); // WebSocket 재연결 시도
      return;
    }
    
    if (tab === "MEMBER"){
      if(document.getElementById("member_id").value == null || document.getElementById("member_id").value == ""){
        swal("이메일을 입력해 주세요.");
        return;
      }else{
        info["email"] = document.getElementById("member_id").value;
      }

      if(document.getElementById("member_password").value == null || document.getElementById("member_password").value == ""){
        swal("비밀번호를 입력해 주세요.");
        return;
      }else{
        info["password"] = document.getElementById("member_password").value;
      }
    }
    if (tab === "PASSCODE"){
      if(document.getElementById("psc_password").value == null || document.getElementById("psc_password").value == ""){
        setLoginError("패스코드를 입력해 주세요."); // ✅ swal 대신 에러 상태
        return;
      }else{
        info["passCode"] = document.getElementById("psc_password").value;
      }
    }

    if (tab === "PARTICIPATION"){
      const partiCode = (document.getElementById("parti_code")?.value || "").trim();
      if(partiCode == ""){
        setLoginError("참가 고유코드를 입력해 주세요.");
        return;
      }else{
        // 사이트 접두어(WEBI-)는 입력창에 고정 표시되므로 참가자는 랜덤부만 입력한다.
        // 제출 시 접두어를 앞에 붙여 전체 코드로 전송한다(이미 붙어있으면 중복 방지).
        const prefix = siteInfo?.accessCodeName ? `${siteInfo.accessCodeName}-` : "";
        info["participationCode"] = (prefix && !partiCode.startsWith(prefix)) ? prefix + partiCode : partiCode;
      }
    }

    if (tab === "PASSCODE"){
      if(passCodeOpt.length > 0){

        let array = passCodeOpt[0];
        
        const param = {
          path: "/v1/client/agreeStatus",
          data: {
            siteIdx: siteInfo.idx,
            passCode: info.passCode
          },
        };

        _API.post(param).then((res) => {
          if(res.data.status == 0){
            if((passCodeUseOpen == false &&  array.termsUseFormUse == "Y") && (passCodePrivacyOpen == false && array.termsPrivacyFormUse == "Y") && (passCodeOverseaOpen == false && array.termsOverseaUse == "Y")){
              setPassCodeUseOpen(true)
              setPassCodePrivacyOpen(true)
              setPassCodeOverseaOpen(true)
              return;
            }
            if((passCodeUseOpen == false &&  array.termsUseFormUse == "Y") && (passCodePrivacyOpen == false && array.termsPrivacyFormUse == "Y")){
              setPassCodeUseOpen(true)
              setPassCodePrivacyOpen(true)
              return;
            }
            if((passCodeUseOpen == false &&  array.termsUseFormUse == "Y") && (passCodeOverseaOpen == false && array.termsOverseaUse == "Y")){
              setPassCodeUseOpen(true)
              setPassCodeOverseaOpen(true)
              return;
            }
            if((passCodePrivacyOpen == false && array.termsPrivacyFormUse == "Y") && (passCodeOverseaOpen == false && array.termsOverseaUse == "Y")){
              setPassCodePrivacyOpen(true)
              setPassCodeOverseaOpen(true)
              return;
            }

            if(passCodePrivacyOpen == false && array.termsPrivacyFormUse == "Y"){
              setPassCodePrivacyOpen(true)
              return;
            }
            if(passCodeUseOpen == false &&  array.termsUseFormUse == "Y"){
              setPassCodeUseOpen(true)
              return;
            }
            if(passCodeOverseaOpen == false &&  array.termsOverseaUse == "Y"){
              setPassCodeOverseaOpen(true)
              return;
            }

            if(array.termsPrivacyFormEsUse == "Y" && passCodePrivacyAgree != true){
              const val = array.termsPrivacyFormLabel;
              alert(`${val}에 동의해 주세요.`);
              return;
            }
            if(array.termsOverseaEsUse == "Y" && passCodeOverseaAgree != true){
              const val = array.termsOverseaLabel;
              alert(`${val}에 동의해 주세요.`);
              return;
            }
            if(array.termsUseFormEsUse == "Y" && passCodeUseAgree != true){
              const val = array.termsUseFormLabel;
              alert(`${val}에 동의해 주세요.`);
              return;
            }
            setFirstLoginStatus(res.data.status)
            goLogin() 
          }else if(res.data.status == -1){
            swal("사이트 초기 옵션을 설정해주세요.");
            return;
          }else{
            goLogin() 
          }
        })
      }else{
        goLogin()
      }
    }else if (tab === "PARTICIPATION"){
      // 고유코드 로그인도 패스코드와 동일한 약관동의 게이트.
      // 동의여부 조회는 participationCode 기준(참가자 단위) — passCode 가 없을 수 있으므로.
      if(passCodeOpt.length > 0){

        let array = passCodeOpt[0];

        const param = {
          path: "/v1/client/agreeStatus",
          data: {
            siteIdx: siteInfo.idx,
            participationCode: info.participationCode
          },
        };

        _API.post(param).then((res) => {
          if(res.data.status == 0){
            if((passCodeUseOpen == false &&  array.termsUseFormUse == "Y") && (passCodePrivacyOpen == false && array.termsPrivacyFormUse == "Y") && (passCodeOverseaOpen == false && array.termsOverseaUse == "Y")){
              setPassCodeUseOpen(true)
              setPassCodePrivacyOpen(true)
              setPassCodeOverseaOpen(true)
              return;
            }
            if((passCodeUseOpen == false &&  array.termsUseFormUse == "Y") && (passCodePrivacyOpen == false && array.termsPrivacyFormUse == "Y")){
              setPassCodeUseOpen(true)
              setPassCodePrivacyOpen(true)
              return;
            }
            if((passCodeUseOpen == false &&  array.termsUseFormUse == "Y") && (passCodeOverseaOpen == false && array.termsOverseaUse == "Y")){
              setPassCodeUseOpen(true)
              setPassCodeOverseaOpen(true)
              return;
            }
            if((passCodePrivacyOpen == false && array.termsPrivacyFormUse == "Y") && (passCodeOverseaOpen == false && array.termsOverseaUse == "Y")){
              setPassCodePrivacyOpen(true)
              setPassCodeOverseaOpen(true)
              return;
            }

            if(passCodePrivacyOpen == false && array.termsPrivacyFormUse == "Y"){
              setPassCodePrivacyOpen(true)
              return;
            }
            if(passCodeUseOpen == false &&  array.termsUseFormUse == "Y"){
              setPassCodeUseOpen(true)
              return;
            }
            if(passCodeOverseaOpen == false &&  array.termsOverseaUse == "Y"){
              setPassCodeOverseaOpen(true)
              return;
            }

            if(array.termsPrivacyFormEsUse == "Y" && passCodePrivacyAgree != true){
              const val = array.termsPrivacyFormLabel;
              alert(`${val}에 동의해 주세요.`);
              return;
            }
            if(array.termsOverseaEsUse == "Y" && passCodeOverseaAgree != true){
              const val = array.termsOverseaLabel;
              alert(`${val}에 동의해 주세요.`);
              return;
            }
            if(array.termsUseFormEsUse == "Y" && passCodeUseAgree != true){
              const val = array.termsUseFormLabel;
              alert(`${val}에 동의해 주세요.`);
              return;
            }
            setFirstLoginStatus(res.data.status)
            goLogin()
          }else if(res.data.status == -1){
            swal("사이트 초기 옵션을 설정해주세요.");
            return;
          }else{
            goLogin()
          }
        })
      }else{
        goLogin()
      }
    }else{
      goLogin()
    }
  };

  const goLogin = () => {
    // 고유코드 로그인 세션 마커(쿠키). iam/JWT 는 이후 access/check 등이 덮어써 participationCode 가 사라지므로,
    // 별도 쿠키로 유지해 EventList 이벤트 전환 시 PARTICIPATION 접속로그 판정에 사용한다. (비고유코드 로그인은 비움)
    _CK.set("partiLoginCode", (tab === "PARTICIPATION" && info.participationCode) ? info.participationCode : "");
    const loginData = {
      email: info.email,
      password: info.password,
      passCode: info.passCode,
      participationCode: info.participationCode,
      siteIdx: siteInfo.idx,
      eventIdx: '',
      tab : tab,
      userAgent: _U.getUserAgent(),
    };
    
    // 실제 환경: connectionId 포함, WebSocket으로 응답 받기
    if (!isLocalEnv) {
      loginData.connectionId = connectionId;
      setIsLoggingIn(true);
      
      const req = {
        path: "/v1/client/login",
        data: loginData,
      };
      
      _API.post(req).then((res) => {
        // SQS 처리 (패스코드 로그인 - PENDING 응답)
        if (res.status === 'SUCCESS' && res.data.status === 'PENDING') {
         
          // WebSocket으로 LOGIN_RESULT 받음 (위 useEffect에서 처리)
        } 
        // 즉시처리 (회원/게스트 로그인 - accessKey 있음)
        else if (res.status === 'SUCCESS' && res.data.accessKey) {
         
          setIsLoggingIn(false);
          
          const { data } = res.data;
          
          // 로그인 데이터 저장
          _CK.setAuth(res.data.accessKey);
          _CK.forceSetLogKey(data?.logKey);
          _CK.setConsoleCountView(0);
          saveIam(data);
          saveAuth(res.data.accessKey);
        } 
        else {
          setIsLoggingIn(false);
          setLoginError("The login request could not be processed."); // ✅ swal 대신 에러 상태
        }
      }).catch((e) => {
        setIsLoggingIn(false);
        console.error("Login API failed:", e);
        setLoginError(e.message || "An error occurred while submitting the login request."); // ✅ swal 대신 에러 상태
      });
      
      return;
    }
    
    // 로컬 환경: 직접 API 호출, 즉시 응답
    const req = {
      path: "/v1/client/login",
      data: loginData,
    };
    
    _API.post(req).then((res) => {
      const { data } = res;
      if (res.status !== "SUCCESS") {
        setLoginError("접근 권한이 없습니다."); // ✅ swal 대신 에러 상태
        return;
      }
      if(tab == 'MEMBER' && eventList?.length <= 0){
        setLoginError("예정중인 이벤트가 없습니다."); // ✅ alert 대신 에러 상태
        return;
      }
      if (tab === "MEMBER" && _CK.get("idCheck") === "Y") {
        _CK.set("email", info.email);
      }
      if ((tab === "PASSCODE" || tab === "PARTICIPATION") && data.accessKey) {
        _CK.setConsoleCountView(0);
        _CK.forceSetLogKey(data?.data?.logKey);  // ✅ logKey 쿠키 저장
        setIam(data.data);
        setAccessKey(data.accessKey);
        setPreregEventList(data.data.preregEventList);
        setPasscodeNext(true);
      } else {
        _CK.setAuth(data.accessKey);
        _CK.forceSetLogKey(data?.data?.logKey);
        _CK.setConsoleCountView(0);
        saveIam(data.data);
        saveAuth(data.accessKey);
      }
    })
    .catch((e) => {
      console.error("Login failed:", e);
      setLoginError(e.message || "접근 권한이 없습니다."); // ✅ swal 대신 에러 상태
    });
  }
  const goEventSessionList = (event, e) => {
    if (e) e.preventDefault();

    if (event?.sessionPubCnt <= 0) {
      alert("예정중인 세션 정보가 없습니다.");
      return;
    }

    // 1️⃣ 먼저 로그 추가
    const existingLogKey = _CK.getLogKey();
    if (existingLogKey) {
      const logReq = {
        path: "/v1/client/add/access/log",
        data: {
          logKey: existingLogKey,
          siteIdx: siteInfo.idx,
          eventIdx: event.idx,
          preregIdx: event.preregIdx,  // 선택한 이벤트의 정확한 preregIdx (고유코드 로그인은 PASS_CODE 조회 불가)
        },
      };
      _API.post(logReq).catch((err) => {
        console.error('add access log error:', err);
      });
    }

    // 2️⃣ 기존 로직: iam 업데이트 후 페이지 이동
    // 패스코드 1차 로그인 응답의 mem.preregIdx는 LIMIT 1로 잡힌 임의의 row(보통 가장 오래된 prereg)이므로
    // 사용자가 선택한 이벤트의 정확한 preregIdx로 갱신해야 register/세션 페이지에서 정합성이 맞는다.
    // event.preregIdx는 백엔드 eventPubList SQL이 이벤트별로 결정적으로 선택해 내려주는 값.
    let newIam = iam;
    newIam.eventIdx = event.idx;
    if (event.preregIdx) {
      newIam.preregIdx = event.preregIdx;
    }
    setIam(newIam);
    
    if(firstLoginStatus == 0){
      const param = {
        path: "/v1/client/termsAgree",
        data: {
          siteIdx: siteInfo.idx,
          passCode : info.passCode,
          passCodeUseAgree : passCodeUseAgree,
          passCodePrivacyAgree : passCodePrivacyAgree,
          passCodeOverseaAgree : passCodeOverseaAgree,
          preregIdx : newIam.preregIdx
        },
      };
      _API.post(param).then((res) => {
        const req = {
          path: "/v1/client/refresh/accessKey", 
          data:{iam:newIam}
        };
        _API.post(req).then((res) => {
          const { accessKey } = res.data;
          
          if (accessKey) {
            if (accessKey.length > 4000) {
              swal("Error", "인증 토큰이 너무 큽니다. 관리자에게 문의하세요.", "error");
              return;
            }
            
            _CK.forceSetLogKey(newIam.logKey);
            saveIam(newIam);
            saveAuth(accessKey);
            _CK.setAuth(accessKey);
            
            setTimeout(()=>{
              history.push(`/event/${event.idx}/register`);
            },100);
          } else {
            console.error('[goEventSessionList] No accessKey in response');
          }
        }).catch((err) => {
          console.error('[goEventSessionList] refresh/accessKey error:', err);
          swal("Error", "페이지 이동 중 오류가 발생했습니다.", "error");
        });
      }).catch((err) => {
        console.error('[goEventSessionList] termsAgree error:', err);
        swal("Error", "약관 동의 처리 중 오류가 발생했습니다.", "error");
      })
    }else{
      const req = {
        path: "/v1/client/refresh/accessKey", 
        data:{iam:newIam}
      };
      _API.post(req).then((res) => {
        const { accessKey } = res.data;
        
        if (accessKey) {
          _CK.setAuth(accessKey);
          
          let retryCount = 0;
          const checkCookieAndNavigate = () => {
            const savedAuth = _CK.getAuth();
            
            if (savedAuth || retryCount >= 10) {
              if (savedAuth) {
                _CK.forceSetLogKey(newIam.logKey);
                saveIam(newIam);
                saveAuth(accessKey);
             
                setTimeout(()=>{
                  history.push(`/event/${event.idx}/register`);
                },100);
              } else {
                console.error('[goEventSessionList] Cookie save failed after retries');
                swal("Error", "인증 정보 저장에 실패했습니다.", "error");
              }
            } else {
              retryCount++;
              setTimeout(checkCookieAndNavigate, 50);
            }
          };
          
          checkCookieAndNavigate();
        } else {
          console.error('[goEventSessionList] No accessKey in response');
        }
      }).catch((err) => {
        console.error('[goEventSessionList] API error:', err);
        swal("Error", "페이지 이동 중 오류가 발생했습니다.", "error");
      });
    }
  };
  
  const goMypage = e => {
    e?.preventDefault();
    let newIam = iam;
    newIam.eventIdx = event.idx;
    setIam(newIam);
    const req = {
      path: "/v1/client/refresh/accessKey",
      data:{iam:newIam}
    };
    _API.post(req).then((res) => {
      const { accessKey } = res.data;
      if (accessKey) {
        _CK.setAuth(accessKey);

        setTimeout(()=>{
          window.location.href = '/#/mypage';
          window.location.reload();
      },300)
      }
    });
  };

  // 🔥 게스트 로그인 핸들러 (guest/save 후 호출)
  // 패스코드와 동일하게 WebSocket + SQS 사용
  const onGuestLogin = (passCode, eventIdx) => {
    // WebSocket 연결 확인
    if (!isLocalEnv && (!isWsReady || !connectionId)) {
      setLoginError("로그인 서비스 연결을 기다려주세요.");
      setWsRetry(c => c + 1);
      return;
    }

    // 게스트 로그인은 goLogin()을 우회하므로 직전 참가고유코드 로그인의 마커 쿠키가 잔존할 수 있다.
    // 접속로그가 PARTICIPATION으로 오기록되지 않도록 여기서 명시적으로 비운다.
    _CK.set("partiLoginCode", "");

    const loginData = {
      passCode: passCode,
      siteIdx: siteInfo.idx,
      eventIdx: eventIdx,
      tab: 'GUEST',
      userAgent: _U.getUserAgent(),
    };

    // 실제 환경: connectionId 포함, WebSocket으로 응답 받기
    if (!isLocalEnv) {
      loginData.connectionId = connectionId;
      setIsLoggingIn(true);

      const req = {
        path: "/v1/client/login",
        data: loginData,
      };

      _API.post(req).then((res) => {
        // SQS 처리 (PENDING 응답) - WebSocket으로 LOGIN_SUCCESS 받음
        if (res.status === 'SUCCESS' && res.data.status === 'PENDING') {
          // WebSocket에서 LOGIN_SUCCESS 메시지를 받으면 처리됨 (기존 useEffect에서)
          console.log('[GUEST LOGIN] Sent to SQS, waiting for WebSocket response');
        }
        // 즉시처리 (accessKey 있음)
        else if (res.status === 'SUCCESS' && res.data.accessKey) {
          setIsLoggingIn(false);
          const { data } = res.data;
          
          _CK.setAuth(res.data.accessKey);
          _CK.forceSetLogKey(data?.logKey);
          _CK.setConsoleCountView(0);
          saveIam(data);
          saveAuth(res.data.accessKey);
          
          // history.push로 이동
          setTimeout(() => {
            history.push(`/event/${eventIdx}/register`);
          }, 100);
        }
        else {
          setIsLoggingIn(false);
          setLoginError("로그인 요청을 처리할 수 없습니다.");
        }
      }).catch((e) => {
        setIsLoggingIn(false);
        console.error("Guest Login API failed:", e);
        setLoginError(e.message || "로그인 중 오류가 발생했습니다.");
      });

      return;
    }

    // 로컬 환경: 즉시 처리
    const req = {
      path: "/v1/client/login",
      data: loginData,
    };

    _API.post(req).then((res) => {
      const { data } = res;
      if (res.status !== "SUCCESS") {
        setLoginError("접근 권한이 없습니다.");
        return;
      }
      
      _CK.setAuth(data.accessKey);
      _CK.forceSetLogKey(data?.data?.logKey);
      _CK.setConsoleCountView(0);
      saveIam(data.data);
      saveAuth(data.accessKey);
      
      // history.push로 이동
      setTimeout(() => {
        history.push(`/event/${eventIdx}/register`);
      }, 100);
    }).catch((e) => {
      console.error("Guest Login failed:", e);
      setLoginError(e.message || "접근 권한이 없습니다.");
    });
  };

  const passCodeShowTerms = (type, e) => {
    if (e) e.preventDefault();
   
    $("body").css("overflow", "hidden");
    
    if (type === "termsUseAgree") {
      setTermsInfo({
         title: passCodeOpt[0]?.termsUseFormLabel,
         content: passCodeOpt[0]?.termsUseForm,
       });
     } else if (type === "termsPrivateAgree") {
      setTermsInfo({
         title: passCodeOpt[0]?.termsPrivacyFormLabel,
         content: passCodeOpt[0]?.termsPrivacyForm,
       });
     }else if (type === "termsOverseaAgree") {
      setTermsInfo({
         title: passCodeOpt[0]?.termsOverseaLabel,
         content: passCodeOpt[0]?.termsOversea,
       });
     }
     else {
      setTermsInfo(null);
     }

  }

  const gstShowTerms = (type, e) => {
    if (e) e.preventDefault();

    $("body").css("overflow", "hidden");

    if (type === "termsUseAgree") {
      setTermsInfo({
        title: siteInfo?.gstTermsUseLabel,
        content: siteInfo?.gstTermsUseForm,
       });
     } else if (type === "termsPrivateAgree") {
       setTermsInfo({
        title: siteInfo?.gstTermsPrivacyLabel,
        content: siteInfo?.gstTermsPrivacyForm,
       });
     }else if (type === "termsOverseaAgree") {
      setTermsInfo({
        title: siteInfo?.gstTermsOverseaLabel,
        content: siteInfo?.gstTermsOverseaForm,
      });
    }
     else if (type === "termsMarketAgree") {
       setTermsInfo({
        title: siteInfo?.gstTermsMarketLabel,
        content: siteInfo?.gstTermsMarketForm,
       });
     }
     else {
       setTermsInfo(null);
     }

  }

  const showTerms = (type, e) => {
    if (e) e.preventDefault();
    $("body").css("overflow", "hidden");

    if (type === "termsUseAgree") {
     setTermsInfo({
        title: "사이트이용약관",
        content: siteInfo?.memTermsUseForm,
      });
    } else if (type === "termsPrivateAgree") {
      setTermsInfo({
        title: "개인정보 수집 이용 동의서",
        content: siteInfo?.memTermsPrivacyForm,
      });
    }
    else if (type === "termsMarket") {
      setTermsInfo({
        title: "마케팅정보 수신동의",
        content: siteInfo?.memTermsMarketForm,
      });
    }
     
    else {
      setTermsInfo(null);
    }
  };

  const linkRel = () => { 
    window.open("https://nedrug.mfds.go.kr/pbp/CCBBB01/getItemDetail?itemSeq=201601746")
  }

  useEffect(() => {
    $("#openModal").click(function (e) {
      e.preventDefault();
      $("body").css("overflow", "hidden");
      setOpenModal(true);
    })
  }, []);
  const BrowserClose = () => {
    $(".modal_container").hide();
  }
  const modalClose = () => {
    setTermsInfo(null);
    setOpenModal(false);
    $("body").css("overflow", "auto");
  };
 
  useEffect(() => {
    eventList, documentRef.current.addEventListener("scroll", handleScroll);
    return () => {
      documentRef.current.removeEventListener("scroll", handleScroll);
    };
  }, [eventList]);
 
  return (
    <Fragment>
      {isLoggingIn && (
        <LoadingSpinner>
          <div className="spinner"></div>
          <div className="loading-text">로그인 중입니다...</div>
        </LoadingSpinner>
      )}
      <div style={{ height: "100%" }}>
        <section id="login_container">
            <div
              className="bg_img"
              style={{
                background: `${siteInfo?.siteMainImgUrl ? `url(${siteInfo?.siteMainImgUrl})` : (`url("https://cdn.onoffevent.com/bg/Site%20bg.png")` )}`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center center",
              }}
            >
              <div className="bg_img_hd">
                {siteInfo?.nameLoginPageShow == 'Y' ? (
                    <h1 style={{ color: siteInfo.nameColor }}>{siteInfo?.title}</h1>
                )
                  : ""
                }
              </div>
            </div>
            <div className="login_inform">
              {(siteInfo?.logoUseYn == "Y" && siteInfo?.logoImgUrl) &&
                <div className="brd_logo" style={{ textAlign: "center" }}>
                  { siteInfo?.logoImgUrl == null || siteInfo?.logoImgUrl == "" ?
                    "" :
                    <img src={siteInfo.logoImgUrl} alt={siteInfo?.name} />
                  }
                </div>
              }
              <div className="login_inform_wrap">
                <ul className="login_inform_list">
                  {loginTabArray.length > 1 ? (
                    <Fragment>
                      {loginTabArray?.map((item, i) => (
                        <li
                          key={i}
                          className={cx({ active: tab === item.key || (item.key === "PASSCODE" && tab === "PARTICIPATION") })}
                          onClick={loginTabChange.bind(this, item.key)}
                          style={{
                            width:
                              "calc( 100% / " + loginTabArray.length + " )",
                          }}
                        >
                          <span className={cx({ on: tab === item.key || (item.key === "PASSCODE" && tab === "PARTICIPATION") })}>
                            {item.name}
                          </span>
                        </li>
                      ))}
                    </Fragment>
                  ) : (
                    <Fragment>
                      {loginTabArray?.map((item, i) => (
                        <div className="login_inform_list_div" key={i}>
                          <span>{item.name}</span>
                        </div>
                      ))}
                    </Fragment>
                  )}
                </ul>
                <form onSubmit={(e) => {e.preventDefault();}}>
                  {tab === "MEMBER" && (
                    <LoginMemberView
                      info={info}
                      idCheck={idCheck}
                      onLoginClick={onLoginClick}
                      clickedIdCheck={clickedIdCheck}
                      onSetInfo={onSetInfo}
                      isLoggingIn={isLoggingIn}
                    />
                  )}
                  {tab === "PASSCODE" && (
                    <LoginPasscodeView
                      info={info}
                      siteInfo={siteInfo}
                      passCodeOpt={passCodeOpt}
                      passcodeNext={passcodeNext}
                      isPasswordVisible={isPasswordVisible}
                      passCodePrivacyOpen={passCodePrivacyOpen}
                      passCodeUseOpen={passCodeUseOpen}
                      passCodeOverseaOpen={passCodeOverseaOpen}
                      onLoginClick={onLoginClick}
                      onSetInfo={onSetInfo}
                      preregEventList={preregEventList}
                      setIsPasswordVisible={setIsPasswordVisible}
                      goEventSessionList={goEventSessionList}
                      goMypage={goMypage}
                      passCodeShowTerms={passCodeShowTerms}
                      passCodePrivacyAgree={passCodePrivacyAgree}
                      passCodeUseAgree={passCodeUseAgree}
                      passCodeOverseaAgree={passCodeOverseaAgree}
                      setPassCodePrivacyAgree={setPassCodePrivacyAgree}
                      setPassCodeUseAgree={setPassCodeUseAgree}
                      setPassCodeOverseaAgree={setPassCodeOverseaAgree}
                      setPassCodePrivacyOpen={setPassCodePrivacyOpen}
                      setPassCodeUseOpen={setPassCodeUseOpen}
                      setPassCodeOverseaOpen={setPassCodeOverseaOpen}
                      loginError={loginError}
                      setLoginError={setLoginError}
                      isLoggingIn={isLoggingIn}
                      loginPartiYn={siteInfo?.loginPartiYn}
                      onSwitchToParticipation={() => { setLoginError(null); setInfo({}); setPasscodeNext(null); setPreregEventList([]); setTab("PARTICIPATION"); }}
                    />
                  )}
                  {tab === "GUEST" && (
                    <LoginGuestView
                      siteInfo={siteInfo}
                      eventList={eventList}
                      onSetEventListActive={onSetEventListActive}
                      gstShowTerms={gstShowTerms}
                      onSetGuestInfoList={onSetGuestInfoList}
                      setGstTermsUseYn={setGstTermsUseYn}
                      setGstTermsMarketYn={setGstTermsMarketYn}
                      setGstTermsOverseaYn={setGstTermsOverseaYn}
                      setGstTermsPrivacyYn={setGstTermsPrivacyYn}
                      gstTermsUseYn={gstTermsUseYn}
                      gstTermsMarketYn={gstTermsMarketYn}
                      gstTermsOverseaYn={gstTermsOverseaYn}
                      gstTermsPrivacyYn={gstTermsPrivacyYn}
                      onGuestLogin={onGuestLogin}
                    />
                  )}
                  {tab === "PARTICIPATION" && (
                    <LoginParticipationView
                      info={info}
                      siteInfo={siteInfo}
                      passcodeNext={passcodeNext}
                      onLoginClick={onLoginClick}
                      preregEventList={preregEventList}
                      goEventSessionList={goEventSessionList}
                      goMypage={goMypage}
                      loginError={loginError}
                      setLoginError={setLoginError}
                      isLoggingIn={isLoggingIn}
                      onSwitchToPasscode={() => { setLoginError(null); setInfo({}); setPasscodeNext(null); setPreregEventList([]); setTab("PASSCODE"); }}
                      passCodeOpt={passCodeOpt}
                      passCodePrivacyOpen={passCodePrivacyOpen}
                      passCodeUseOpen={passCodeUseOpen}
                      passCodeOverseaOpen={passCodeOverseaOpen}
                      passCodePrivacyAgree={passCodePrivacyAgree}
                      passCodeUseAgree={passCodeUseAgree}
                      passCodeOverseaAgree={passCodeOverseaAgree}
                      setPassCodePrivacyAgree={setPassCodePrivacyAgree}
                      setPassCodeUseAgree={setPassCodeUseAgree}
                      setPassCodeOverseaAgree={setPassCodeOverseaAgree}
                      passCodeShowTerms={passCodeShowTerms}
                    />
                  )}
                </form>
                {/* {showPreregPromotion && (
                  <div className="w-full mt-10">
                    <div className="max-w-[360px] mx-auto flex flex-col self-stretch pb-4 justify-center items-start gap-4">
                      <div className="self-stretch flex flex-col justify-start items-start gap-2">
                        <div data-property-1="Group Title" className="w-96 h-8 flex flex-col justify-center items-start">
                          <div className="self-stretch justify-center text-zinc-700 text-lg font-bold font-['Noto_Sans_CJK_KR'] leading-normal">사전등록 바로가기</div>
                        </div>
                      </div>
                      <div className="self-stretch flex flex-col justify-start items-end gap-4">
                        <div className="self-stretch flex flex-col justify-start items-start">
                          <div className="self-stretch inline-flex justify-start items-start gap-3">
                            <img className="size-20 rounded-md border border-zinc-700/5" src={WinrevairThumbnail} />
                            <div className="flex-1 inline-flex flex-col justify-center items-start gap-1">
                              <div className="size- inline-flex justify-start items-center gap-1">
                                <div data-property-1="Online" className="size- min-w-8 h-4 px-1 bg-white rounded-sm outline outline-1 outline-offset-[-1px] outline-[#b871ff] flex justify-center items-center">
                                  <div className="text-center justify-center text-[#b871ff] text-xs font-normal font-['Noto_Sans_KR'] leading-none">ONLINE</div>
                                </div>
                                <div data-property-1="Live" className="size- min-w-8 h-4 px-1 bg-white rounded-sm outline outline-1 outline-offset-[-1px] outline-rose-500 flex justify-center items-center">
                                  <div className="text-center justify-center text-rose-500 text-xs font-normal font-['Noto_Sans_KR'] leading-none">LIVE</div>
                                </div>
                              </div>
                              <div className="self-stretch inline-flex justify-center items-center">
                                <div className="flex-1 justify-center text-zinc-700 text-base font-medium font-['Noto_Sans_KR'] leading-tight">“SAY YES TO MORE” <br/>윈레브에어 론칭 심포지엄</div>
                              </div>
                              <div className="self-stretch justify-start text-zinc-500 text-xs font-normal font-['Noto_Sans_KR'] leading-none">2025.10.01(수) 07:00 ~ 2025.11.06(목) 23:59</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="self-stretch flex flex-col justify-start items-start gap-3">
                        <a href="https://winrevair.livee.kr/#/campaign/87" target="_blank" data-size="Default" data-status="Default" className="self-stretch h-12 px-4 py-2 bg-[#e58ca4] rounded-md inline-flex justify-center items-center">
                          <span className="text-center justify-center text-white text-sm font-medium font-['Noto_Sans_KR'] leading-tight">사전등록 바로가기</span>
                        </a>
                      </div>
                    </div>
                  </div>
                )} */}
                {(siteInfo?.isCampaignUse && campaignList?.length > 0) ? (
                  <>
                    <div className="campaign_list_container flex flex-col mx-auto pb-4 mt-8">
                      <div className="flex flex-col gap-y-4">
                        <h3 className="campaign_list_title text-medium-700 text-foreground">진행중인 캠페인</h3>
                        <ul className="campaign_list self-stretch flex flex-col justify-start items-stretch">
                          {campaignList.slice(0, visibleCampaignCount)?.map((item, index) => {
                            return (
                              <li key={item.idx} className="campaign_list_item self-stretch inline-flex justify-start items-start">
                                <div className="campaign_list_thumb flex justify-start items-center rounded-md overflow-hidden">
                                  <img src={item?.campaignBgUrl ? item.campaignBgUrl : defaultImg} alt="" className="w-full h-full object-cover" />
                                </div>
                                <div className="campaign_list_body flex-1 inline-flex flex-col justify-center items-start">
                                  <div className="campaign_badge_row flex justify-start items-center gap-1">
                                    {item?.progressTarget == 'ON' && (
                                      <span className="campaign_badge campaign_badge_online">ONLINE</span>
                                    )}
                                    {item?.progressTarget == 'OFF' && (
                                      <span className="campaign_badge campaign_badge_offline">OFFLINE</span>
                                    )}
                                    {item?.progressTarget == 'ONOFF' && (
                                      <span className="campaign_badge campaign_badge_onoff">ONOFF</span>
                                    )}
                                  </div>
                                  <div className="campaign_list_name self-stretch inline-flex justify-center items-center">
                                    <div className="flex-1 justify-center text-small text-foreground">
                                      <a href={`https://${item.domain}/#/campaign/${item.idx}`} target="_blank">
                                        {item.name}
                                      </a>
                                    </div>
                                  </div>
                                  <div className="campaign_list_date self-stretch justify-start text-extra-small text-secondary-foreground-light">
                                    {item.startDate &&
                                      moment(item.startDate).format("YYYY.MM.DD(ddd) HH:mm")} {" "}
                                    {item.endDate && ` ~ `}
                                    {item.endDate &&
                                      (moment(item.startDate).format("YYYY.MM.DD(ddd)") ===
                                        moment(item.endDate).format("YYYY.MM.DD(ddd)")
                                        ? moment(item.endDate).format("HH:mm")
                                        : moment(item.endDate).format("YYYY.MM.DD(ddd) HH:mm"))}
                                  </div>
                                </div>
                              </li>
                            )
                          })}
                        </ul>
                      </div>

                      {visibleCampaignCount < campaignList.length && (
                        <div className="campaign_more_button w-fit ml-auto mt-[16px] flex justify-end items-center cursor-pointer" onClick={handleShowMoreCampaign}>
                          <div className="text-center justify-center text-extra-small-label text-foreground">캠페인 더보기</div>
                        </div>
                      )}
                    </div>
                  </>
                ) : ''}
                <div className="cs_container">
                  <h4>{siteInfo?.cs}</h4>
                  <p dangerouslySetInnerHTML={{ __html: siteInfo?.csDescription }}/>
                 {/*  <p>{siteInfo?.csDescription}</p>
                  {siteInfo?.csRegCheck == "Y" ? <p>{siteInfo?.csRegTel}</p> : ""}
                  {siteInfo?.csAccessCheck == "Y" ? (
                    <p>{siteInfo?.csAccessTel}</p>
                  ) : (
                    ""
                  )} */}
                </div>
                <div className="bg_img_ft">
                  <pre
                    dangerouslySetInnerHTML={{
                      __html: siteInfo?.footer?.replace(/\n/g, ""),
                    }}
                  />
                  {tab == "MEMBER" && siteInfo?.memberFooterCheck === "Y" ? (
                    <div className="ft_info2" style={{ marginTop: "30px" }}>
                      <a onClick={showTerms.bind(this, "termsPrivateAgree")}>개인정보처리방침.</a>
                      <a onClick={showTerms.bind(this, "termsUseAgree")}>이용약관</a>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </section>
          {termsInfo && (
            <Fragment>
              <div className="ft_modal_container">
                <div className="ft_modal_header">
                  <div>
                    <h2>{termsInfo?.title}</h2>
                    <button
                      className="close_btn"
                      href=""
                      onClick={(e) => {
                        e.preventDefault();
                        modalClose();
                      }}
                    >
                      <img src="https://cdn.onoffevent.com/common/icon_close.svg" />
                    </button>
                  </div>
                </div>
                <div className="ft_modal_content">
                  <div
                    dangerouslySetInnerHTML={{ __html: termsInfo?.content }}
                  />
                </div>
              </div>
              <div className="modal_bg on"></div>
            </Fragment>
          )}
          {openModal && (
            <div className="modal_container">
              <button className="modal_close" onClick={modalClose}><img src="https://cdn.onoffevent.com/common/icon_close.svg" alt="닫기"/></button>
              <div className="modal_mid">
                <h4 style={{fontSize: "19px", wordBreak: "keep-all"}}>
                  당신은 한국 GSK 웹 사이트에서
                  다른 페이지로 이동하려고 하고 있습니다.<br/>
                  이 링크를 클릭하면 다른 웹 사이트 또는 웹 채널로 이동하게 됩니다.
                </h4>
                <span>
                  지금 이동하려는 페이지는 한국 GSK의 유관 사이트이거나
                  한국 규정이 적용되지 않는 글로벌 GSK 사이트 또는 계열사일 수 있습니다.
                  GSK가 관리하지 않거나 GSK가 소유하지 않은 제3자 사이트로 이동할 경우,
                  GSK는 해당 사이트에서 제공하는 콘텐츠에 대해 책임지지 않습니다.
                </span>
              </div>
              <div className="btnBox">
                <button className="modalBtn cancelBtn" onClick={modalClose}>취소</button>
                <button className="modalBtn confirmBtn" onClick={linkRel}>계속</button>
              </div>
            </div>
          )}

         {/*  {!isKakao ? (
              <div className="modal_mid">
              <ul>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      openInChrome(e)
                    }}
                  >
                    <img src={ChromeLogo} alt="chrome logo" />
                    <span>Chrome</span>
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={() => {
                      console.log(1234);
                    }}
                  >
                    <img src={SafariLogo} alt="safari logo" />
                    <span>Safari</span>
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      openInEdge(e)
                    }}
                  >
                    <img src={EdgeLogo} alt="edge logo" />
                    <span>Edge</span>
                  </a>
                </li>
              </ul>
       
            </div>
          ) : */} 
           {!iosOk && (
           (isKakao || isSamsungBrowser) ? (<>
            <div className="modal_container">
                <button className="modal_close" onClick={BrowserClose}><img src="https://cdn.onoffevent.com/common/icon_close.svg" alt="닫기" /></button>
                <div className="modal_mid">
                  <h4>
                    아래 Chrome/Edge를 통해 <br/>
                    접속해주세요.
                  </h4>
                  <span>
                    현재 접속하신 브라우저에서는 서비스 이용에 어려움이 있을 수 있습니다.
                  </span>
                  <span style={{ display: "block", marginTop: 8, fontWeight: "bold" }}>
                    아래 아이콘을 누르면 해당 브라우저로 자동 이동합니다.
                  </span>
                  <ul>
                    <li>
                      <a href="#" onClick={(e) => { e.preventDefault(); openInChrome(e); }}>
                        <img src={ChromeLogo} alt="chrome logo" style={{ width: 60, height: 60 }}/>
                        <span>Chrome으로 열기</span>
                        <small style={{ display: "block", marginTop: 4, color: "#888", fontSize: 11 }}>
                          앱이 없으면 스토어로 이동
                        </small>
                      </a>
                    </li>
                    {!isAndroid && !isTablet ? (
                      <li>
                        <a href="https://support.apple.com/ko_KR/downloads/safari" target="_blank">
                          <img src={SafariLogo} alt="safari logo" style={{ width: 60, height: 60 }}/>
                          <span>Safari 다운로드</span>
                          <small style={{ display: "block", marginTop: 4, color: "#888", fontSize: 11 }}>
                            Apple 공식 페이지
                          </small>
                        </a>
                      </li>
                    ) : ''}
                    <li>
                      <a href="#" onClick={(e) => { e.preventDefault(); openInEdge(e); }}>
                        <img src={EdgeLogo} alt="edge logo" style={{ width: 60, height: 60 }}/>
                        <span>Edge로 열기</span>
                        <small style={{ display: "block", marginTop: 4, color: "#888", fontSize: 11 }}>
                          앱이 없으면 스토어로 이동
                        </small>
                      </a>
                    </li>
                  </ul>
                  <span style={{textAlign:"center"}}>
                    아이콘을 탭하면 해당 브라우저 앱이 자동으로 열립니다.<br/>
                    설치되어 있지 않으면 앱스토어/플레이스토어로 이동합니다.
                  </span>
                </div>
                <div className="btnBox">
                  <button className="modalBtn cancelBtn" onClick={BrowserClose}>닫기</button>
                </div>
              </div>
          </>) : (!isAndroid && _U.getUserAgent().browserName != "Chrome")
            && (!isAndroid && _U.getUserAgent().browserName != "Safari")
            && (!isAndroid && _U.getUserAgent().browserName != "Mobile Safari")
            && (!isAndroid && _U.getUserAgent().browserName != "Edge") ? (
              <div className="modal_container">
                <button className="modal_close" onClick={BrowserClose}><img src="https://cdn.onoffevent.com/common/icon_close.svg" alt="닫기" /></button>
                <div className="modal_mid">
                  <h4>
                    {/* 현재 접속하신 브라우저에서는 서비스 이용에 어려움이 있을 수 있습니다.<br/> */}
                    원활한 서비스 이용을 위해 <br/>
                    Chrome/Safari/Edge를 통한 접속을 부탁드립니다.
                  </h4>
                  <span>
                    For a seamless service experience, please access via Chrome, Safari, or Edge.
                  </span>
                </div>
                <div className="btnBox">
                  <button className="modalBtn cancelBtn" onClick={BrowserClose}>닫기</button>
                </div>
              </div>
          ) : null )}
        </div>
        <DynamicStyles />
      </Fragment>
    );
  };
